import React from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';

import useSession from 'core/hooks/use-session';
import { useQuery, gql } from '@apollo/client';
import { useStore } from 'core/store/store.mobx';
import { MyCommunity } from '../my-community';
import { Pledges } from '../pledges';
import { CustomerAdditionalOffersSection } from '../customer-additional-offers-section';
import { MicroDeposits } from '../micro-deposits';
import { AccountDetails } from '../account-details';
import { AgentDetails } from '../agent-details';
import { MarketTierCard } from '../market-tier-card';
import useStyles from './sidebar.styles';

const CustomerSidebar = observer((props) => {
  const {
    account,
    account: {
      policies,
      policies: { achPoliciesWithUniqueBankId },
      marketTierRating,
      accountLoading
    }
  } = useStore();
  const recentPolicy = policies.getRecentPolicy(); // Using getRecentPolicy() here as per discussion in issue #21742 - life insurance eligibility doesn't require an active policy

  const classes = useStyles();
  const { canEditPolicies, canSeeMarketTierCard } = useSession();

  const assurityLifeEligibilityQuery = useQuery(
    gql`
      query ($policyId: String) {
        assurityLifeCheckEligibility(args: { branchPolicyId: $policyId }) {
          __typename
          ... on AssurityLifeCheckEligibilitySuccessResponse {
            staffUserCapabilities
            eligibleLifeOffers {
              personId
              benefitAmount
              monthlyPremiumAmount
              annualPremiumAmount
            }
          }
        }
      }
    `,
    { variables: { policyId: recentPolicy?.id }, skip: !recentPolicy?.id }
  );

  const shouldShowAssurityTermLifeAdditionalOffer = Boolean(
    !assurityLifeEligibilityQuery.loading &&
      assurityLifeEligibilityQuery.data?.assurityLifeCheckEligibility.__typename !==
        'AssurityLifeCheckEligibilityStaffUserNotEligibleResponse'
  );

  const shouldShowAdditionalOffers = shouldShowAssurityTermLifeAdditionalOffer;

  return (
    <Grid container>
      <Grid item className={classes.bottomSpacing}>
        <AccountDetails {...props} />
      </Grid>
      {!!marketTierRating && canSeeMarketTierCard && (
        <Grid item className={classes.gridItem}>
          <MarketTierCard {...props} marketTierRating={marketTierRating} accountLoading={accountLoading} />
        </Grid>
      )}
      {canEditPolicies && !!achPoliciesWithUniqueBankId.length && account.id === props.accountId && (
        <Grid item className={classes.bottomSpacing}>
          <MicroDeposits {...props} />
        </Grid>
      )}
      <Grid item className={classes.gridItem}>
        <AgentDetails {...props} />
      </Grid>
      {shouldShowAdditionalOffers && (
        <Grid item className={classes.gridItem}>
          <CustomerAdditionalOffersSection
            assurityTermLife={shouldShowAssurityTermLifeAdditionalOffer}
            assurityTermLifeData={{
              ...assurityLifeEligibilityQuery?.data?.assurityLifeCheckEligibility,
              email: account.email
            }}
          />
        </Grid>
      )}
      <Grid item className={classes.gridItem}>
        <MyCommunity {...props} />
      </Grid>
      <Grid item className={classes.gridItem}>
        <Pledges {...props} />
      </Grid>
    </Grid>
  );
});

export default CustomerSidebar;
